import React, {
  useState,
} from "react";

import {
  AdminNavigationTab,
  AdminNavigationTabs,
} from "../navigation_engine";

import EmployeeEmploymentSection
  from "./EmployeeEmploymentSection";

import EmployeeIdentitySection
  from "./EmployeeIdentitySection";

import EmployeeOrganizationSection
  from "./EmployeeOrganizationSection";

import EmployeeOverviewSection
  from "./EmployeeOverviewSection";


const SECTION_KEYS =
  Object.freeze({
    OVERVIEW: "overview",
    IDENTITY: "identity",
    EMPLOYMENT: "employment",
    ORGANIZATION: "organization",
  });


export default function EmployeeWorkspaceSections({
  detail,
  identityActions = null,
}) {
  const [
    activeSection,
    setActiveSection,
  ] = useState(
    SECTION_KEYS.OVERVIEW,
  );

  const employee =
    detail?.employee ?? {};

  const user =
    detail?.user ?? null;

  const employment =
    detail?.employment ?? null;

  const organization =
    detail?.organization ?? {
      establishment: null,
      department: null,
      position: null,
      manager: null,
    };


  const renderSection = () => {
    switch (activeSection) {
      case SECTION_KEYS.IDENTITY:
        return (
          <EmployeeIdentitySection
            employee={employee}
            user={user}
            actions={identityActions}
          />
        );

      case SECTION_KEYS.EMPLOYMENT:
        return (
          <EmployeeEmploymentSection
            employment={employment}
          />
        );

      case SECTION_KEYS.ORGANIZATION:
        return (
          <EmployeeOrganizationSection
            organization={organization}
          />
        );

      case SECTION_KEYS.OVERVIEW:
      default:
        return (
          <EmployeeOverviewSection
            employee={employee}
            user={user}
            employment={employment}
            organization={organization}
          />
        );
    }
  };


  return (
    <>
      <AdminNavigationTabs
        aria-label={
          "Navigation des sections Employee"
        }
      >
        <AdminNavigationTab
          active={
            activeSection
            === SECTION_KEYS.OVERVIEW
          }
          onClick={() => {
            setActiveSection(
              SECTION_KEYS.OVERVIEW,
            );
          }}
        >
          Vue d'ensemble
        </AdminNavigationTab>

        <AdminNavigationTab
          active={
            activeSection
            === SECTION_KEYS.IDENTITY
          }
          onClick={() => {
            setActiveSection(
              SECTION_KEYS.IDENTITY,
            );
          }}
        >
          Identité
        </AdminNavigationTab>

        <AdminNavigationTab
          active={
            activeSection
            === SECTION_KEYS.EMPLOYMENT
          }
          onClick={() => {
            setActiveSection(
              SECTION_KEYS.EMPLOYMENT,
            );
          }}
        >
          Employment
        </AdminNavigationTab>

        <AdminNavigationTab
          active={
            activeSection
            === SECTION_KEYS.ORGANIZATION
          }
          onClick={() => {
            setActiveSection(
              SECTION_KEYS.ORGANIZATION,
            );
          }}
        >
          Organisation
        </AdminNavigationTab>
      </AdminNavigationTabs>

      {renderSection()}
    </>
  );
}


export {
  SECTION_KEYS,
};
